import { IonSpinner } from "@ionic/react";
import { useEffect, useState } from "react";

export default function ApiLoadingIndicator() {
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    function handleLoadingChange(event) {
      setIsLoading(Boolean(event.detail?.isLoading));
    }

    window.addEventListener("metora:api-loading", handleLoadingChange);

    return () => window.removeEventListener("metora:api-loading", handleLoadingChange);
  }, []);

  useEffect(() => {
    if (!isLoading) {
      setIsVisible(false);

      return undefined;
    }

    const timer = window.setTimeout(() => setIsVisible(true), 150);

    return () => window.clearTimeout(timer);
  }, [isLoading]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="api-loading-indicator" role="status" aria-label="Loading" aria-live="polite">
      <IonSpinner name="crescent" />
    </div>
  );
}
